import { TraceEvents } from '../call-trace-event';
import { find, last } from 'lodash';
import { byName } from './util';
function groupEventsByParticipants(events) {
    const participantEventNames = new Set([
        TraceEvents.ConnectionCreated,
        TraceEvents.ConnectionDestroyed,
        TraceEvents.ParticipantVideoAppeared,
    ]);
    return events
        .filter((e) => participantEventNames.has(e.name))
        .reduce((res, event) => {
        res[event.data.uuid] = res[event.data.uuid] || [];
        res[event.data.uuid].push(event);
        return res;
    }, {});
}
export function selectParticipantStreamDelays(events) {
    const groupedParticipants = groupEventsByParticipants(events);
    return Object.keys(groupedParticipants).map((uuid) => {
        const participantEvents = groupedParticipants[uuid];
        const connectionCreated = find(participantEvents, byName(TraceEvents.ConnectionCreated));
        if (connectionCreated.data.onlyChat) {
            const noDelay = {
                uuid,
                delay: 0,
                systemInfo: connectionCreated.data.systemInfo,
            };
            return noDelay;
        }
        const connectionDestroyed = find(participantEvents, byName(TraceEvents.ConnectionDestroyed));
        const videoAppeared = find(participantEvents, byName(TraceEvents.ParticipantVideoAppeared));
        const startEvent = connectionCreated;
        const endEvent = videoAppeared || connectionDestroyed || last(events);
        return {
            uuid,
            systemInfo: connectionCreated.data.systemInfo,
            delay: endEvent.timestamp - startEvent.timestamp,
        };
    });
}
